import Icon from "../Icon";

const CockpitYoutubePlayer = ({ id, className, style, videoId, title }) => {
  return videoId ? (
    <div id={id} className={className} style={{ ...style }}>
      <iframe
        width="100%"
        style={{ aspectRatio: "16/9", ...style }}
        src={`https://www.youtube.com/embed/${videoId}?modestbranding=1&showinfo=0&rel=0&theme=light&fs=0&color=white`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  ) : (
    <div className="empty-msg">
      <div>
        <Icon name="face-sad-tear" size="4x" />
      </div>
      <div>Missing videoId</div>
    </div>
  );
};

export default CockpitYoutubePlayer;
